import {
    FaSatelliteDish,
    FaInstagram,
    FaFacebookF,
    FaYoutube,
    FaTelegram,
  } from 'react-icons/fa6'
  
  const footerLinks = [
    {
      title: 'Produk',
      links: ['Fitur', 'Harga', 'Integrasi', 'API Dokumentasi', 'Changelog'],
    },
    {
      title: 'Perusahaan',
      links: ['Tentang Kami', 'Karir', 'Blog', 'Kemitraan', 'Kontak'],
    },
    {
      title: 'Dukungan',
      links: [
        'Pusat Bantuan',
        'Panduan Setup',
        'Video Tutorial',
        'Komunitas',
        'Status Server',
      ],
    },
  ]
  
  const socials = [
    { icon: FaInstagram, label: 'Instagram' },
    { icon: FaFacebookF, label: 'Facebook' },
    { icon: FaYoutube, label: 'YouTube' },
    { icon: FaTelegram, label: 'Telegram' },
  ]
  
  export default function Footer() {
    return (
      <footer className="relative border-t border-navy-500/20" role="contentinfo">
        <div className="max-w-7xl mx-auto px-6 py-16">
          <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-10">
            {/* Brand */}
            <div className="lg:col-span-2">
              <a href="#" className="flex items-center gap-3 mb-5">
                <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-ocean-800 to-ocean-600 flex items-center justify-center">
                  <FaSatelliteDish className="text-white text-lg" />
                </div>
                <span className="font-display font-bold text-xl text-white">
                  Radius<span className="text-ocean-500">Trend</span>
                </span>
              </a>
              <p className="text-slate-custom text-sm leading-relaxed mb-6 max-w-sm">
                Platform billing system terintegrasi yang dirancang khusus untuk
                Internet Service Provider dan RT/RW Net di Indonesia.
              </p>
              <div className="flex gap-3">
                {socials.map((s, i) => {
                  const Icon = s.icon
                  return (
                    <a
                      key={i}
                      href="#"
                      className="w-9 h-9 rounded-lg bg-navy-700/50 border border-navy-500/30 flex items-center justify-center text-slate-custom hover:text-ocean-500 hover:border-ocean-600/40 transition-all"
                      aria-label={s.label}
                    >
                      <Icon className="text-xs" />
                    </a>
                  )
                })}
              </div>
            </div>
  
            {/* Link Columns */}
            {footerLinks.map((col, i) => (
              <div key={i}>
                <h4 className="font-display font-semibold text-white text-sm mb-4">
                  {col.title}
                </h4>
                <ul className="space-y-2.5">
                  {col.links.map((link, j) => (
                    <li key={j}>
                      <a
                        href="#"
                        className="text-slate-custom text-sm hover:text-ocean-500 transition-colors"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
  
          <div className="section-line mt-12 mb-8" aria-hidden="true" />
  
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-slate-custom/60">
            <p>
              &copy; {new Date().getFullYear()} Radius Trend. Seluruh hak cipta
              dilindungi.
            </p>
            <div className="flex gap-6">
              <a
                href="#"
                className="hover:text-slate-custom transition-colors"
              >
                Kebijakan Privasi
              </a>
              <a
                href="#"
                className="hover:text-slate-custom transition-colors"
              >
                Syarat & Ketentuan
              </a>
            </div>
          </div>
        </div>
      </footer>
    )
  }